import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Card } from "@mui/material";
import OrdersModalTable from "./OrdersModalTable";
import { useTranslation } from "context/TranslationProvider";

const UserOrdersModal = ({ isOpen, toggle, orders = [], isLoading }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      className="modal-dialog-centered"
    >
      <ModalHeader toggle={toggle}>
        {t("page.userListings.deliveries", "Deliveries")}
      </ModalHeader>

      <ModalBody className="mt--3">
        <Card elevation={0} className="border">
          <OrdersModalTable items={orders} isLoading={isLoading} />
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default UserOrdersModal;
